// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__ulsI0","buttons":"RemoveExpirationActionButtons_buttons__3gkO2"};